import React from 'react'
import "./Dronathon.css"
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/Dronathon.pdf"
const Dronathon = () => {
  return (
    <div className='drone_container'>
    <div className="title">
        <h2>Dronathon</h2>            
    </div>
    <div className="evt_data">
        <div className="left">
            {/* <img src={img1} alt="" /> */}
        </div>
        <div className="right">
            <div className="r_detail">
            <p>Mar 14,2023</p>
            <h2>Drone Competition</h2>
            </div>
            <div className="reg_data">
                <div className="flex-cont">
            <div className="evt_reg">
                <h2>Entry Fee : Rs. 100</h2>
                <div className="reg_btns">
                <Link to="https://docs.google.com/forms/d/e/1FAIpQLSfUBHlfa75578KHLb2Vmiw6vVuPWCRSNnWtmf731HpGH3bmWQ/viewform" target="_blank" className="reg_btn">Register Now</Link>
                </div>
                </div>
            </div>
            <div className="desc">
                <h3>Description</h3>
                 <p>Dronathon is an event that involves racing and obstacle courses for unmanned aerial vehicles (UAVs), also known as drones. The event typically attracts both amateur and professional drone pilots who compete against each other in various challenges that test their drone flying skills and agility.</p>
                 <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link>
            </div>
            <div className="date">
                <h3>Date & Time</h3>
                <div className="date_data">
                    <h4>Mar 14,2023</h4>
                </div>
            </div>
            <div className="loc">
                <h3>Location</h3>
                <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
            </div>
            <div className="team">
                <h3><span>Coordinator</span> Team</h3>
                <div className="staf_team">
                    <h4>Staff Co-ordinator</h4>
                    <p>Sandip Awachar : +91 99602 50362</p>
                </div>
                <div className="team_data">
                    <h4>Student Co-ordinator</h4>
                    <p>SAKINA ALI : +91 9518745894</p>
                    <p>BILAL SHAIKH: +91 9130357782</p>
                    <p>RAJ ANASANE: +91 9552423278</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Dronathon